import React, { useState, useEffect } from "react";
import Autocomplete from "react-autocomplete";
import { Controller } from "react-hook-form";
import CustomerApi from "service/customerApi";
import { currentDate } from "utils/formatDate";

export const AutoCompleteKhachHang = ({
  UpdateKhachHang,
  dataThanhLy,
  setDataThanhLy,
  taiSanId,
  errors,
  setErrors,
}) => {
  const [value, setValue] = useState("");

  const [autocompleteData, setAutocompleteData] = useState([]);

  const [showClear, setShowClear] = useState(false);
  useEffect(() => {
    //alert('hehe');
    async function fetchMyAPI() {
      const tukhoa = {
        tuKhoa: "",
      };
      const response = await CustomerApi.Autocomplete.call(null, tukhoa);
      //alert(response);
      setAutocompleteData(response.data);
    }

    fetchMyAPI();
  }, []);

  const register = () => {};

  const onChangeCustomerText = (field) => (event) => {
    CustomerApi.Autocomplete(event.target.value);
  };
  const onSelectCustomer = (value, item) => {
    // setValue(value);
    const initData = {
      TaiSanID: taiSanId,
      KhachHang_Id: item.CustomerID,
      TenKhachHang: item.DinhDanh,
      NgayThanhLy: currentDate(),
      GhiChu: "",
      TienThanhLy: "",
      TienKhachTra: "",
      PhiKhac: "",
    };
    UpdateKhachHang(initData);
    setShowClear(true);
    setAutocompleteData([]);
  };

  const onChange = (field) => (e) => {
    setDataThanhLy({
      ...dataThanhLy,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        tenKhachHang: "Nhập tên người nhận",
      });
    } else {
      setErrors({
        ...errors,
        tenKhachHang: "",
      });
    }
    //alert('thuty');
    // setValue(value);
    async function fetchMyAPI() {
      const tukhoa = {
        tuKhoa: e.target.value,
      };
      const response = await CustomerApi.Autocomplete.call(null, tukhoa);
      //alert(response);
      setAutocompleteData(response.data);
    }

    fetchMyAPI();
  };

  return (
    <>
      {/* <input
        type="hidden"
        name="CustomerID"
        value={CustomerID}
        ref={register}
      ></input>
      <input
        type="hidden"
        name="customer.CustomerID"
        value={CustomerID}
        ref={register}
      ></input> */}

      <div className="form-group ">
        <label className="color7-bold" >Thanh lý cho</label>

        <div class="input-group">
          <Autocomplete
            wrapperProps={{}}
            wrapperStyle={{
              position: "relative",
              width: "100%",
            }}
            inputProps={{
              className: "form-control input-sm card-autocomplete",
              // readOnly: !IsEditCustomer.IsAllow,
            }}
            menuStyle={{
              borderRadius: "3px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
              background: "rgba(255, 255, 255, 0.9)",
              padding: "2px 0",
              fontSize: "90%",
              position: "absolute",
              overflow: "auto",
              maxHeight: "150px", // TODO: don't cheat, let it flow to the bottom
              top: "0 !important",
              left: "0 !important",
              zIndex: "1000",
            }}
            getItemValue={(item) => item.DinhDanh}
            items={autocompleteData}
            renderItem={(item, isHighlighted) => {
              return (
                <div
                  className="auto-list"
                  style={{
                    background: isHighlighted ? "lightgray" : "white",
                    textTransform: "capitalize",
                  }}
                >
                  {item.DinhDanh}
                </div>
              );
            }}
            value={dataThanhLy.TenKhachHang}
            onSelect={(value, item) => {
              onSelectCustomer(value, item);
              //onChange();
            }}
            // onChange={(event, value) => {
            //   onChange(event, value);
            //   //onChangeCustomerText('CustomerName')(e);
            // }}
            onChange={onChange("TenKhachHang")}
          />
        </div>
        {errors.tenKhachHang && (
          <span className="canh-bao-red">{errors.tenKhachHang}</span>
        )}
      </div>
    </>
  );
};
